// Builds the `fieldPlaceholders` snapshot a TEMPLATE-mode form node stamps onto its
// componentData so downstream ${placeholder} autocomplete works without an S2S template
// fetch. Each entry carries the RAW FormCore field type ({key, label, type}); the workflow
// engine maps it to a placeholder type via the canonical FieldPlaceholderTypes mapper when it
// reads the snapshot, so the type is identical whether the node is INLINE or TEMPLATE and the
// mapping lives in exactly one place (the backend). The repeatable_section flattening
// (parent.child keys) mirrors the engine's getPlaceholder traversal.

/**
 * @param {Array} fields FormCore fields[] from a template's published payload
 * @returns {Array<{key: string, label: string, type: string}>}
 */
export function buildFieldPlaceholders(fields) {
  const out = [];
  if (!Array.isArray(fields)) return out;
  for (const field of fields) {
    const key = field?.key;
    if (!key || typeof key !== 'string') continue;
    out.push({ key, label: field.label || key, type: field.type || 'text' });
    if (field.type === 'repeatable_section' && Array.isArray(field.children)) {
      for (const child of field.children) {
        const childKey = child?.key;
        if (!childKey || typeof childKey !== 'string') continue;
        out.push({
          key: `${key}.${childKey}`,
          label: child.label || childKey,
          type: child.type || 'text',
        });
      }
    }
  }
  return out;
}

export default buildFieldPlaceholders;
